// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"menu-unfold"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M5.79297 12.75L7.35547 11H4.23047L5.79297 12.75Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M21 19L3 19M21 5H3M21 12L12 12","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M5.79297 12.75L7.35547 11H4.23047L5.79297 12.75Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-menu-unfold')
export default class MenuUnfoldIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'menu-unfold',
    }
  }
}
